// extracted by mini-css-extract-plugin
export default {"card":"O2-z"};